import { useState } from 'react';
import './login.css';
import starLogoImg from '../assets/icon.png';
import ziniPeaceImg from '../assets/neutral.png';
import * as authService from '../services/authService';

function PersonIcon() {
  return (
    <svg width="19" height="19" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="8" r="3.6" stroke="#7457e8" strokeWidth="1.8" />
      <path d="M5 20c0-3.9 3.1-7 7-7s7 3.1 7 7" stroke="#7457e8" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

function LockIcon() {
  return (
    <svg width="19" height="19" viewBox="0 0 24 24" fill="none">
      <rect x="5" y="11" width="14" height="10" rx="2.5" stroke="#7457e8" strokeWidth="1.8" />
      <path d="M8 11V8a4 4 0 0 1 8 0v3" stroke="#7457e8" strokeWidth="1.8" strokeLinecap="round" />
      <circle cx="12" cy="16" r="1.6" fill="#7457e8" />
    </svg>
  );
}

function EyeIcon({ open }) {
  if (open) {
    return (
      <svg width="19" height="19" viewBox="0 0 24 24" fill="none">
        <path
          d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7Z"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinejoin="round"
        />
        <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.8" />
      </svg>
    );
  }
  return (
    <svg width="19" height="19" viewBox="0 0 24 24" fill="none">
      <path
        d="M3 3l18 18M10.6 10.7a3 3 0 0 0 4.2 4.2M6.6 6.7C4 8.4 2 12 2 12s4 7 11 7c1.6 0 3-.3 4.3-.9M9.9 5.1A11.5 11.5 0 0 1 12 5c7 0 11 7 11 7-.5.9-1.3 2-2.4 3"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ArrowRightIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path d="M5 12h13M13 6l6 6-6 6" stroke="#6c4ce8" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function SparkleIcon({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M12 2c.6 3.4 2.2 5.4 6 6-3.8.6-5.4 2.6-6 6-.6-3.4-2.2-5.4-6-6 3.8-.6 5.4-2.6 6-6Z"
        fill="currentColor"
      />
    </svg>
  );
}

function ScribbleIcon({ className }) {
  return (
    <svg className={className} viewBox="0 0 20 24" fill="none" aria-hidden="true">
      <path d="M14 3c-5 3-5 12 0 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

function PaperPlaneIcon({ className }) {
  return (
    <svg className={className} viewBox="0 0 28 28" fill="none" aria-hidden="true">
      <path d="M2 15.5 25 4 15 25l-3.4-8.2L2 15.5Z" fill="#7457e8" />
      <path d="M11.6 16.8 21 8l-9.4 10.2v-1.4Z" fill="#5b3fd6" />
    </svg>
  );
}

function PlantIcon({ className }) {
  return (
    <svg className={className} viewBox="0 0 44 52" fill="none" aria-hidden="true">
      <path
        d="M16 25c-5-6-4-15 3-19 1 7-1 14-3 19Z"
        fill="#8a6df1"
      />
      <path
        d="M20 25c0-8 5-14 12-15-1 8-5 14-12 15Z"
        fill="#7457e8"
      />
      <path
        d="M18 25c-2-7 1-13 6-16 0 7-2 12-6 16Z"
        fill="#a691f2"
      />
      <path d="M10 26h20l-2.6 21a3 3 0 0 1-3 2.6H15.6a3 3 0 0 1-3-2.6L10 26Z" fill="#6c4ce8" />
      <path d="M9 26h22v3a1.6 1.6 0 0 1-1.6 1.6H10.6A1.6 1.6 0 0 1 9 29v-3Z" fill="#5b3fd6" />
    </svg>
  );
}

function CupIcon({ className }) {
  return (
    <svg className={className} viewBox="0 0 32 44" fill="none" aria-hidden="true">
      <rect x="3" y="7" width="26" height="7" rx="3.5" fill="#8a6df1" />
      <path d="M6 13h20l-2.4 25.5a3 3 0 0 1-3 2.7H11.4a3 3 0 0 1-3-2.7L6 13Z" fill="#7457e8" />
      <path
        d="M16 20.5 17.3 24l3.7.4-2.8 2.5.8 3.6L16 28.6l-3 1.9.8-3.6-2.8-2.5 3.7-.4Z"
        fill="#fff"
      />
    </svg>
  );
}

function validateLoginId(value) {
  const id = value.trim();
  if (!id) return 'Enter your phone number, username or email.';
  const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(id);
  const isPhone = /^\+?\d{7,15}$/.test(id.replace(/[\s-]/g, ''));
  const isUsername = /^[a-zA-Z0-9_.]{3,}$/.test(id);
  if (!isEmail && !isPhone && !isUsername) {
    return 'Enter a valid phone number, username or email.';
  }
  return '';
}

function validatePassword(value) {
  if (!value) return 'Enter your password.';
  if (value.length < 6) return 'Password must be at least 6 characters.';
  return '';
}

export default function Login({ onLoginSuccess, onSkip }) {
  const [showPassword, setShowPassword] = useState(false);
  const [loginId, setLoginId] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const nextErrors = {
      loginId: validateLoginId(loginId),
      password: validatePassword(password),
    };
    setErrors(nextErrors);
    if (nextErrors.loginId || nextErrors.password) return;

    setIsSubmitting(true);
    try {
      const result = await authService.login(loginId.trim(), password);
      setErrors({});
      onLoginSuccess?.(result.user);
    } catch (err) {
      setErrors((prev) => ({ ...prev, general: err.message || 'Login failed. Please try again.' }));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-screen">
      <div className="login-frame">
        <div className="login-hero">
          <span className="login-dot-grid" aria-hidden="true" />
          <SparkleIcon className="login-sparkle login-sparkle-1" />
          <SparkleIcon className="login-sparkle login-sparkle-2" />
          <PaperPlaneIcon className="login-plane" />
          <svg className="login-plane-trail" viewBox="0 0 46 34" fill="none" aria-hidden="true">
            <path
              d="M2 4c8 14 22 22 40 26"
              stroke="#b7a2f5"
              strokeWidth="2"
              strokeLinecap="round"
              strokeDasharray="1 7"
            />
          </svg>
          <PlantIcon className="login-plant" />
          <CupIcon className="login-cup" />

          {/* <button
            type="button"
            className="login-skip-btn"
            onClick={() => (onSkip ? onSkip() : onLoginSuccess?.())}
          >
            Skip
          </button> */}

          <div className="login-brand">
            <div className="login-brand-name-row">
              <ScribbleIcon className="login-brand-scribble login-brand-scribble-left" />
              {/* <img src={starLogoImg} alt="" className="login-brand-mark" />
              <span className="login-brand-name">
                Deal<span className="login-brand-name-accent">Zta</span>
              </span> */}
              <ScribbleIcon className="login-brand-scribble login-brand-scribble-right" />
            </div>
            <p className="login-tagline">
              Discover More,
              <br />
              Just Next Door
            </p>
          </div>

          <div className="login-char-wrap">
            <div className="login-char-glow" />
            <img src={ziniPeaceImg} alt="Zini" className="login-char-img" />
          </div>
        </div>

        <form className="login-card" onSubmit={handleSubmit} noValidate>
          <h2 className="login-welcome">
            Welcome{' '}
            <span className="login-welcome-accent">
              Back!
              <svg className="login-welcome-underline" viewBox="0 0 90 12" fill="none" aria-hidden="true">
                <path d="M2 8c14-8 60-8 86 1" stroke="#6c4ce8" strokeWidth="3" strokeLinecap="round" />
              </svg>
            </span>
          </h2>
          {/* <p className="login-card-subtitle">Sign in to discover amazing offers and deals near you.</p> */}

          <div className="login-field">
            <div className={'login-input-wrap' + (errors.loginId ? ' login-input-wrap-error' : '')}>
              <PersonIcon />
              <input
                id="login-id"
                type="text"
                placeholder="Phone number, username or email"
                value={loginId}
                onChange={(e) => {
                  setLoginId(e.target.value);
                  if (errors.loginId || errors.general) setErrors((prev) => ({ ...prev, loginId: '', general: '' }));
                }}
                aria-invalid={Boolean(errors.loginId)}
                aria-describedby={errors.loginId ? 'login-id-error' : undefined}
              />
            </div>
            {errors.loginId && (
              <p className="login-field-error" id="login-id-error">
                {errors.loginId}
              </p>
            )}
          </div>

          <div className="login-field">
            <div className={'login-input-wrap' + (errors.password ? ' login-input-wrap-error' : '')}>
              <LockIcon />
              <input
                id="password"
                type={showPassword ? 'text' : 'password'}
                placeholder="Password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  if (errors.password || errors.general) setErrors((prev) => ({ ...prev, password: '', general: '' }));
                }}
                aria-invalid={Boolean(errors.password)}
                aria-describedby={errors.password ? 'password-error' : undefined}
              />
              <button
                type="button"
                className="login-eye-btn"
                onClick={() => setShowPassword((v) => !v)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                <EyeIcon open={showPassword} />
              </button>
            </div>
            {errors.password && (
              <p className="login-field-error" id="password-error">
                {errors.password}
              </p>
            )}
          </div>

          {errors.general && (
            <p className="login-field-error login-general-error" role="alert">
              {errors.general}
            </p>
          )}

          <button type="submit" className="login-submit" disabled={isSubmitting} aria-busy={isSubmitting}>
            <span className="login-submit-text">{isSubmitting ? 'Logging in…' : 'Log In'}</span>
            <span className="login-submit-arrow">
              <ArrowRightIcon />
            </span>
          </button>

          {/* <p className="login-forgot-row">
            Forgot password?{' '}
            <button type="button" className="login-link">
              Get Help Signing in.
            </button>
          </p> */}

          <div className="login-divider">
            <span>or</span>
          </div>

          <p className="login-signup">
            Don&apos;t have an account?{' '}
            <button
              type="button"
              className="login-link"
              onClick={() => window.open('https://dealzta.com/download', '_blank', 'noopener,noreferrer')}
            >
              Sign up.
            </button>
          </p>
        </form>
      </div>
    </div>
  );
}
